// A simple utility to track button clicks with Meta Pixel
// This helps keep tracking logic consistent and avoids errors if the fbq function isn't available.

export const trackButtonClick = (buttonName, details = {}) => {
  if (typeof fbq === 'function') {
    fbq('trackCustom', 'ButtonClick', {
      button_name: buttonName,
      page_path: window.location.pathname,
      ...details,
    });
  } else {
    console.warn('Meta Pixel (fbq) not found. Button click not tracked.');
  }
};

export const trackLead = (leadDetails) => {
  if (typeof fbq === 'function') {
    fbq('track', 'Lead', leadDetails);
  } else {
    console.warn('Meta Pixel (fbq) not found. Lead not tracked.');
  }
};